import axios from 'axios';
import { baseAPI } from '../config';

const getAuthHeaders = () => ({
  Authorization: `Bearer ${localStorage.getItem('token')}`,
});

/**
 * List unmatched whatsapps (admin + gestor; scoped by company server-side).
 * @param {Object} params - { page, limit, status, search, startDate, endDate }
 * @returns {Promise<Object>} { whatsapps, pagination }
 */
export const getUnmatchedWhatsapps = async (params = {}) => {
  try {
    const response = await axios.get(`${baseAPI}/whatsapps/unmatched`, {
      headers: getAuthHeaders(),
      params,
    });
    return response.data;
  } catch (error) {
    console.error('Error getting unmatched whatsapps:', error);
    throw error;
  }
};

/**
 * Get count of pending unmatched whatsapps (scoped by company).
 * @returns {Promise<number>} Count
 */
export const getUnmatchedWhatsappsCount = async () => {
  try {
    const response = await axios.get(`${baseAPI}/whatsapps/unmatched/count`, {
      headers: getAuthHeaders(),
    });
    return response.data.count;
  } catch (error) {
    console.error('Error getting unmatched whatsapps count:', error);
    throw error;
  }
};

/**
 * Get single unmatched whatsapp details.
 * @param {string} whatsappId
 * @returns {Promise<Object>}
 */
export const getUnmatchedWhatsapp = async whatsappId => {
  try {
    const response = await axios.get(`${baseAPI}/whatsapps/unmatched/${whatsappId}`, {
      headers: getAuthHeaders(),
    });
    return response.data;
  } catch (error) {
    console.error('Error getting unmatched whatsapp:', error);
    throw error;
  }
};

/**
 * Assign an unmatched whatsapp to an expedient.
 * @param {string} whatsappId
 * @param {string} expedientId
 * @returns {Promise<Object>} Result with interaction
 */
export const assignWhatsappToExpedient = async (whatsappId, expedientId) => {
  try {
    const response = await axios.post(
      `${baseAPI}/whatsapps/unmatched/${whatsappId}/assign`,
      { expedient_id: expedientId },
      { headers: getAuthHeaders() }
    );
    return response.data;
  } catch (error) {
    console.error('Error assigning whatsapp:', error);
    throw error;
  }
};

/**
 * Ignore an unmatched whatsapp.
 * @param {string} whatsappId
 * @returns {Promise<Object>} Result
 */
export const ignoreUnmatchedWhatsapp = async whatsappId => {
  try {
    const response = await axios.post(
      `${baseAPI}/whatsapps/unmatched/${whatsappId}/ignore`,
      {},
      { headers: getAuthHeaders() }
    );
    return response.data;
  } catch (error) {
    console.error('Error ignoring whatsapp:', error);
    throw error;
  }
};
